import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output, Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgForm} from '@angular/forms';
import {firstNestedSymbolControl, NumberControl} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ISymbol} from '@lv1871/core';
import {EventService} from '../../../services/event.service';
import {StageConfigService} from '../../../services/stage-config.service';

@Component({
    selector: 'lv-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SliderComponent),
        }
    ],
    standalone: false
})
export class SliderComponent implements OnInit, AfterViewInit {
  @Output()
  public sliderValue = new EventEmitter<any>();

  @ViewChild(NgForm, {static: true})
  private _ngForm: NgForm;

  public sliderStep: number = 1;
  public sliderLabel: boolean;
  public sliderMinDescription: string | number;
  public sliderMaxDescription: string | number;
  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public autocomplete: string;

  private _uiArtefakt: NumberControl;

  constructor(private _cd: ChangeDetectorRef, private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService, private _uiUpdateService: UiUpdateService,
              private _eventService: EventService, private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): NumberControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: NumberControl) {
    this._uiArtefakt = uiArtefakt;
    this.sliderStep = this._uiArtefakt?.SliderSchrittweite || 1;
    this.sliderLabel = this._uiArtefakt?.SliderLabelAnzeigenJN || false;
    this._cd.markForCheck();
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public ngOnInit() {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
    this._setSliderDecription();
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this._uiArtefakt, this._ngForm);

  }

  public changeValue(value: any, isValid: boolean) {
    if (value + '' === this._uiArtefakt.WertEingabe + '') {
      return;
    }
    if (!value && value !== 0) {
      this.uiArtefakt.WertEingabe = null;
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
      return;
    }
    if (!isValid) {
      return;
    }
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
    this._uiArtefakt.WertEingabe = +value;
    this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt);
  }

  public setSliderValue(changedValue: number): void {
    this.changeValue(changedValue, true);
    this._ngForm.control.markAllAsTouched();
    this._cd.markForCheck();
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  private _setSliderDecription() {
    if (!!this._uiArtefakt.Einheit) {
      this.sliderMinDescription = 'min. ' + this._uiArtefakt.WertEingabeMin + ' ' + this._uiArtefakt.Einheit;
      this.sliderMaxDescription = 'max. ' + this._uiArtefakt.WertEingabeMax + ' ' + this._uiArtefakt.Einheit;
    } else {
      this.sliderMinDescription = this._uiArtefakt.WertEingabeMin;
      this.sliderMaxDescription = this._uiArtefakt.WertEingabeMax;
    }
  }

}
